module.exports = __webpack_public_path__ + "static/media/quiz-arrow-right.96ff5724.svg";